export const categoryItems = [
  { title: "", value: "" },
  { title: "Attendance (Daily)", value: "attendance" },
  { title: "Attendance (Monthly)", value: "attendanceSummary" },
  { title: "Class Diary", value: "classDiary" },
  { title: "Nap", value: "nap" },
  { title: "Growth Record", value: "growth" },
  { title: "Monthly Staff Schedule", value: "shiftPatternMonthly" },
  { title: "Daily Staff Schedule", value: "shiftPatternDaily" },
  { title: "Development Record Sheet", value: "childDevelopment" },
  { title: "Progress Record", value: "childDevelopmentRecord" },
  { title: "VEVO Report", value: "childDevelopmentAiReport" },

/* 発達記録Excel出力（Vue3対応完了後に対応するため一時コメントアウト）　　　　feat(child-development): excel exports
  { text: "", value: "" },
  { text: "出席簿(日次)", value: "attendance" },
  { text: "出席簿(月次)", value: "attendanceSummary" },
  { text: "クラス日誌", value: "classDiary" },
  { text: "午睡", value: "nap" },
  { text: "成長記録", value: "growth" },
  { text: "月次スタッフ予定", value: "shiftPatternMonthly" },
  { text: "日次スタッフ予定", value: "shiftPatternDaily" },
  { text: "発達記録表", value: "childDevelopment" },
  { text: "経過記録", value: "childDevelopmentRecord" },
*/
];

export const statusItems = [
  { title: "", value: "" },
  { title: "Completed", value: "completed" },
  { title: "In Progress", value: "inProgress" },
  { title: "Timeout", value: "timeout" },
  { title: "Failed", value: "failed" },
];
